<script lang="ts" setup>
import { Slot } from 'radix-vue'
// import { useFormField } from './useFormField'
//
// const { error, formItemId, formDescriptionId, formMessageId } = useFormField()
</script>

<template>
  <Slot>
    <slot />
  </Slot>
</template>
